export const headingTagInput = ({label='Tag', updateTo=''})=>{
    return ({
      inputType: "select",
      label: label,
      hasStyleProps: false,
      updateTo:updateTo,
      options: [    
        {
          display: "Default",
          value: "",
        },          
        {
          display: "H1",
          value: "h1",
        },
        {
          display: "H2",
          value: "h2",
        },
        {
          display: "H3",
          value: "h3",
        },
        {
          display: "P",
          value: "p",
        }
      ],
      hideLabel: false,
    })
  }